const settingsGuardian = () => {
  return () => {
    window.location.href = `${import.meta.env.VITE_DEEPADMIN_BASE_URL}account/signature`;
  };
};

export default settingsGuardian;
